import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "steps" }
const _hoisted_2 = {
  key: 0,
  class: "step__basic"
}
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { for: "title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Нажмите чтобы загрузить готовое приложение", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { for: "title" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Нажмите чтобы загрузить готовое приложение", -1)
const _hoisted_12 = {
  key: 1,
  class: "uploadfile_photo"
}
const _hoisted_13 = { class: "left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Добавьте горизонтальное обзорное фото вывески сбоку")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"18px"} }, "Пример изображения"),
  /*#__PURE__*/_createElementVNode("img", { src: "https://api.rekprof.ru/files/sample/spb/perspectiva.jpg" })
], -1)
const _hoisted_16 = {
  key: 2,
  class: "uploadfile_photo"
}
const _hoisted_17 = { class: "left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Добавьте горизонтальное обзорное фото вывески вблизи")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"18px"} }, "Пример изображения"),
  /*#__PURE__*/_createElementVNode("img", { src: "https://api.rekprof.ru/files/sample/spb/front_in.jpg" })
], -1)
const _hoisted_20 = {
  key: 3,
  class: "uploadfile_photo"
}
const _hoisted_21 = { class: "left" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Добавьте горизонтальное обзорное фото вывески издалека")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"18px"} }, "Пример изображения"),
  /*#__PURE__*/_createElementVNode("img", { src: "https://api.rekprof.ru/files/sample/spb/front_out.jpg" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass({activeStep: _ctx.subpage == 1}),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.subpage = 1))
      }, "Шаг 1", 2),
      ((_ctx.document.app3_file_checked == 0 && _ctx.document.construction_app6 == false) || (_ctx.document.app6_file_checked == 0 && _ctx.document.construction_app6))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass({activeStep: _ctx.subpage == 2}),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.subpage = 2))
          }, "Шаг 2", 2))
        : _createCommentVNode("", true),
      ((_ctx.document.app3_file_checked == 0 && _ctx.document.construction_app6 == false) || (_ctx.document.app6_file_checked == 0 && _ctx.document.construction_app6))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass({activeStep: _ctx.subpage == 3}),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.subpage = 3))
          }, "Шаг 3", 2))
        : _createCommentVNode("", true),
      ((_ctx.document.app3_file_checked == 0 && _ctx.document.construction_app6 == false) || (_ctx.document.app6_file_checked == 0 && _ctx.document.construction_app6))
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: _normalizeClass({activeStep: _ctx.subpage == 4}),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.subpage = 4))
          }, "Шаг 4", 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.subpage == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.document.construction_app6 == false)
              ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, [
                    _createVNode(_component_v_switch, {
                      style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
                      color: "#2F80ED",
                      modelValue: _ctx.document.app3_file_checked,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.app3_file_checked) = $event)),
                      label: "Использовать готовое приложение №3",
                      inline: ""
                    }, null, 8, ["modelValue"]),
                    (_ctx.document.app3_file_checked == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("input", {
                            ref: "app3_file",
                            type: "file",
                            accept: ".pdf",
                            hidden: "",
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitFile('app3_file')))
                          }, null, 544),
                          _hoisted_7,
                          _createElementVNode("button", {
                            class: "btn_upload",
                            style: {"width":"480px"},
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$refs.app3_file.click()))
                          }, "Загрузить файл приложения №3 на сервер"),
                          _createElementVNode("span", {
                            style: {"cursor":"pointer"},
                            onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+_ctx.route.query.id+'&hash='+_ctx.route.query.hash+'&type=app3_file', _ctx.document.app3_file.split('/')[_ctx.document.app3_file.split('/').length-1]);})
                          }, "Файл приложения №3 - " + _toDisplayString(_ctx.document.app3_file.split('/')[_ctx.document.app3_file.split('/').length-1] == "" ? 'не загружен' : _ctx.document.app3_file.split('/')[_ctx.document.app3_file.split('/').length-1]), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.document.construction_app6)
              ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, [
                    _createVNode(_component_v_switch, {
                      style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
                      color: "#2F80ED",
                      modelValue: _ctx.document.app6_file_checked,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.document.app6_file_checked) = $event)),
                      label: "Использовать готовое приложение №6",
                      inline: ""
                    }, null, 8, ["modelValue"]),
                    (_ctx.document.app6_file_checked == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("input", {
                            ref: "app6_file",
                            type: "file",
                            accept: ".pdf",
                            hidden: "",
                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitFile('app6_file')))
                          }, null, 544),
                          _hoisted_11,
                          _createElementVNode("button", {
                            class: "btn_upload",
                            style: {"width":"480px"},
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$refs.app6_file.click()))
                          }, "Загрузить файл приложения №6 на сервер"),
                          _createElementVNode("span", {
                            style: {"cursor":"pointer"},
                            onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+_ctx.route.query.id+'&hash='+_ctx.route.query.hash+'&type=app6_file', _ctx.document.app6_file.split('/')[_ctx.document.app6_file.split('/').length-1]);})
                          }, "Файл приложения №6 - " + _toDisplayString(_ctx.document.app6_file.split('/')[_ctx.document.app6_file.split('/').length-1] == "" ? 'не загружен' : _ctx.document.app6_file.split('/')[_ctx.document.app6_file.split('/').length-1]), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.subpage == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_FileUpload, {
              document: _ctx.document,
              file_upload_name: 'construction_perspective_file',
              upload_text: 'Добавьте фото в поле ниже. Соотношение сторон 3Шx2В. Пример: 604px x 402px'
            }, null, 8, ["document", "upload_text"])
          ]),
          _hoisted_15
        ]))
      : _createCommentVNode("", true),
    (_ctx.subpage == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_FileUpload, {
              document: _ctx.document,
              file_upload_name: 'construction_around_file',
              upload_text: 'Добавьте фото в поле ниже. Соотношение сторон 3Шx2В. Пример: 604px x 402px'
            }, null, 8, ["document", "upload_text"])
          ]),
          _hoisted_19
        ]))
      : _createCommentVNode("", true),
    (_ctx.subpage == 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_FileUpload, {
              document: _ctx.document,
              file_upload_name: 'construction_away_file',
              upload_text: 'Добавьте фото в поле ниже. Соотношение сторон 3Шx2В. Пример: 604px x 402px'
            }, null, 8, ["document", "upload_text"])
          ]),
          _hoisted_23
        ]))
      : _createCommentVNode("", true)
  ], 64))
}